import axios from "axios";
import { config } from "./host";

const decode = (val) => decodeURIComponent(escape(atob(val)));

const getCookie = (name) => {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? decode(match[2]) : null;
};

const api = axios.create({
  baseURL: config.apiHostGw,
});

api.interceptors.request.use(
  function (config) {
    const token = getCookie("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

export default api;
